import React, {useState} from 'react';
import {FlatList, TouchableOpacity} from 'react-native';
import {
   drawerListIconSelectedColor,
   drawerListIconUnSelectedColor,
   drawerListTextSelectedColor,
   drawerListTextUnSelectedColor,
   drawerListSelectedBackgroundColor,
} from '../../utils/utils';

const CourseResourcesList = ({
   ListHeaderComponent,
   data,
   renderItem,
   onSelect,
   ItemSeparatorComponent,
}) => {
   const [selected, setSelected] = useState(false);

   const handlePress = item => {
      setSelected(item);
      onSelect(item);
   };

   const renderItemWithSelection = ({item, index, locked}) => {
      const isSelected = item === selected;
      const backgroundColor = 'transparent';
      const iconTintColor = isSelected
         ? drawerListIconSelectedColor
         : drawerListIconUnSelectedColor;
      const titleColor = isSelected
         ? drawerListTextSelectedColor
         : drawerListTextUnSelectedColor;
      return (
         <TouchableOpacity
            onPress={() => handlePress(item)}
            style={{backgroundColor}}>
            {renderItem({
               item,
               iconTintColor,
               titleColor,
               isSelected,
               index,
               locked,
            })}
         </TouchableOpacity>
      );
   };

   return (
      <FlatList
         ListHeaderComponent={ListHeaderComponent}
         data={data}
         renderItem={renderItemWithSelection}
         ItemSeparatorComponent={ItemSeparatorComponent}
      />
   );
};

export default CourseResourcesList;
